import React from "react" 
import main from "../Contents/main.module.css"
import LoadingIcon from "./LoadingIcon";

export default class Popup extends React.Component 
{
    static defaultProps={
        innerClassName:"",
        text:"defaultText",
        okButtonText:"Yes",
        cancelButtonText:"Cancel",
        okPopupFunction:()=>alert("Please, create the okPopupFunction"),
        closePopupFunction:()=>alert("Please, create the closePopupFunction"),

    };

    constructor(props) 
    {
        super(props);
        this.state = {
            loading:false,
        };
    }

    render(){
        return(
            <div className={main.confirmationPopup}>  
                <div className={main.confirmationPopup_inner +" "+this.props.innerClassName}>
                    <div className = "container-fluid">
                        <div className = "row">
                            <div className = "col"><h5>{this.props.text}</h5><br /></div>           
                        </div>
                    </div>
                    <div className = "container-fluid">
                        { this.state.loading
                            ? <div className="row"><div className="col-12"><LoadingIcon loading={true}/></div></div>
                            :   <div className = "row">
                                    <div className="col-1"></div>
                                    <div 
                                        className = "col-4 p-1" 
                                        style={{visibility: this.props.cancelButtonText ? "visible" : "hidden"}}
                                        onClick={this.props.closePopupFunction}
                                    >
                                        {
                                            this.props.cancelButtonText
                                            ?
                                                <button className="w-100 btn btn-primary btn-sm">
                                                    {this.props.cancelButtonText}
                                                </button>
                                            :   ' '
                                        }
                                    </div>
                                    <div className="col-2"></div>
                                    <div 
                                        className = "col-4 p-1 pointer"
                                        onClick={()=>{
                                            this.setState({loading:true})
                                            this.props.okPopupFunction();
                                        }}
                                    >
                                        <button className="w-100 btn btn-primary btn-sm">
                                            {this.props.okButtonText}
                                        </button>
                                    </div>
                                    <div className="col-1"></div>
                                </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}